let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1TuRF")).then(() => parcelRequire('e1ZeM'));